import { headerAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const launchDarkly = defineConnector({
  identifier: "launchDarkly",
  name: "LaunchDarkly",
  tagLine: "Feature flag management",
  logo,
  protocol: "http",
  tags: ["engineering"],
  defaultUrlPattern: () => "https://app\\.launchdarkly\\.com/.*",
  auth: (app) =>
    headerAuth([{ name: "Authorization", value: app.secret.accessToken }]),
  steps: [
    {
      title: "Get your LaunchDarkly access token",
      items: [
        {
          kind: "markdown",
          content:
            "In LaunchDarkly, go to **Account settings > Authorization** and create a new access token with the permissions you need.",
        },
      ],
    },
    {
      title: "Enter your access token",
      items: [
        {
          kind: "input",
          label: "Access token",
          required: true,
          target: { kind: "secrets", field: "accessToken" },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: () => "https://app.launchdarkly.com/api/v2/tokens",
  },
});
